/** Options for case-request steps GET (view / update). */
export type CaseRequestViewOptions = {
  /**
   * When `'original'`, append `?view=original` so the API returns the
   * immutable submitted snapshot (Case Details tab).
   * Omit (or `'latest'`) for the editable update instance (Case Update tab) —
   * the API defaults to `latest` when `view` is not sent.
   */
  view?: 'original' | 'latest';
  signal?: AbortSignal;
};

/**
 * Build steps GET path with optional `view` query.
 * - Case Details: `?view=original`
 * - Case Update: omit param (API returns latest by default)
 */
export function caseRequestStepsPath(basePath: string, options?: CaseRequestViewOptions): string {
  if (options?.view === 'original') {
    const sep = basePath.includes('?') ? '&' : '?';
    return `${basePath}${sep}view=original`;
  }
  return basePath;
}
